import { Fragment, useState } from 'react';
import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DiscardDialog } from './DiscardDialog';
export function Discard(props) {
    const { feedbackId } = props;
    const [displayDialog, setDisplayDialog] = useState(false);
    const showDialog = () => setDisplayDialog(true);
    const closeDialog = () => setDisplayDialog(false);
    return (<Fragment>
      {displayDialog && <DiscardDialog onClose={closeDialog} feedbackId={feedbackId}/>}
      <Button size="small" appearance="ghost" onClick={showDialog}>
        <Falcon icon="trash"/>
        <Trans comment="Plai Review - Issue description - discard button - label">Discard</Trans>
      </Button>
    </Fragment>);
}
